import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { ReactComponent as ErrorSvg } from "./assets/error.svg";
import { ReactComponent as WarningSvg } from "./assets/warning.svg";
import styles from "./ErrorTile.module.styl";

function ErrorTile({ position, severity, text, description }) {
    const positionClass = styles["position_" + position];

    return (
        <div className={cx(positionClass)}>
            <div className={styles.tile}>
                <div className={cx(styles.header)}>
                    {severity === "error" && <ErrorSvg />}
                    {severity === "warning" && <WarningSvg />}
                    <span className={styles.text}>{text}</span>
                </div>
                {description && (
                    <div>
                        <p className={styles.description}>{description}</p>
                    </div>
                )}
            </div>
        </div>
    );
}

ErrorTile.propTypes = {
    position: PropTypes.oneOf(["block", "centered", "margin-auto", "fill"]),

    severity: PropTypes.oneOf(["error", "warning"]),

    text: PropTypes.string,
    description: PropTypes.string,
};

ErrorTile.defaultProps = {
    position: "block",
    severity: "error",
    text: "Произошла ошибка",
    description:
        "В данный момент на сайте возникли перебои, мы уже работаем над этим. Попробуйте загрузить страницу чуть позже.",
};

export default ErrorTile;
